export function registerPwa(): void {
	if (!('serviceWorker' in window.navigator)) return;
	const register = () => {
		const url = new URL('service-worker.js', document.baseURI);
		window.navigator.serviceWorker.register(url.href, { updateViaCache: 'none' })
			.catch(error => console.warn('PWA service worker registration failed.', error));
	};
	if (document.readyState === 'complete') register();
	else window.addEventListener('load', register, { once: true });
}
